import { ApiProperty } from "@nestjs/swagger";

export class DateReq {

    @ApiProperty()
    date: string;

    constructor(date: string) {
        this.date = date;
    }
}